"use client"
import { pipe } from "fp-ts/function"
import {
  BottomSheet,
  BottomSheetTitle,
} from "@/components/common/bottomSheet/components/BottomSheetMenu"
import { BookshelfExtractConfirmationProps } from "./_types"
import { useBookshelfAnalysis } from "./_hooks/useBookshelfAnalysis"
import { useBookshelfActions } from "./_hooks/useBookshelfActions"
import LoadingState from "./_components/LoadingState"
import EmptyState from "./_components/EmptyState"
import BookListContent from "./_components/BookListContent"
import { LOG_T_SHELF_BY_CAMERA_FAIL } from "@/components/log/taggingIds"

/**
 * 책장 분석 결과 확인 컴포넌트
 */
const BookshelfExtractConfirmation = ({
  analysisId,
  onComplete,
  removeProcessedId,
  captureDate,
}: BookshelfExtractConfirmationProps) => {
  // 커스텀 Hook으로 분리된 상태 관리와 로직
  const { books, isLoading, analysisStatus } = useBookshelfAnalysis({
    analysisId,
    removeProcessedId,
  })

  const { handleClose, handleRetakePhoto, handleAddToLibrary, selectedCount } =
    useBookshelfActions({
      analysisId,
      books,
      onComplete,
    })

  // 조건부 렌더링을 위한 상태 확인
  const isEmpty = analysisStatus === "error" || analysisStatus === "empty"

  // 상태별 컴포넌트 렌더링
  const renderContent = () => {
    if (isLoading || analysisStatus === "loading") {
      return <LoadingState />
    }

    if (isEmpty) {
      return <EmptyState onRetakePhoto={handleRetakePhoto} />
    }

    return (
      <BookListContent
        books={books}
        selectedCount={selectedCount}
        onAddToLibrary={handleAddToLibrary}
        captureDate={captureDate}
      />
    )
  }

  return pipe(renderContent(), (content) => (
    <BottomSheet
      title={
        <BottomSheetTitle
          title="책장 도서 등록 확인"
          btnId={LOG_T_SHELF_BY_CAMERA_FAIL}
        />
      }
      layout="full"
      onClose={isEmpty ? undefined : handleClose}
    >
      <div className="flex h-full flex-1 flex-col overflow-y-auto overscroll-y-contain">
        {content}
      </div>
    </BottomSheet>
  ))
}

export default BookshelfExtractConfirmation
